var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.869507,
    y: 0.313477,
    width: 45.6788,
    height: 45.6788,
    rx: 15,
    fill: "#FF1133",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6614 10.999C28.1631 11.7336 27.5528 12.4739 26.9597 13.1926C25.6449 14.7864 24.2852 16.4343 24.2852 17.8999C24.2852 20.3017 26.2405 22.2562 28.6437 22.2562C31.0457 22.2562 33 20.3017 33 17.8999C33 16.4472 31.6343 14.7702 30.3134 13.1481C29.7369 12.4409 29.1441 11.7125 28.6614 10.999ZM28.5583 20.6748C27.05 20.6748 25.823 19.4486 25.823 17.9407C25.823 17.7833 25.9505 17.6559 26.1079 17.6559C26.2653 17.6559 26.3926 17.7834 26.3926 17.9407C26.3926 19.1339 27.3641 20.1049 28.5586 20.1049C28.716 20.1049 28.8433 20.2329 28.8433 20.3898C28.8427 20.5473 28.7157 20.6748 28.5583 20.6748L28.5583 20.6748Z",
    fill: "#FF1133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1376 19.5488C20.4385 20.6014 19.5613 21.6646 18.7099 22.6965C16.8862 24.9068 15.0001 27.1932 15.0001 29.25C15.0001 32.6192 17.7422 35.3601 21.113 35.3601C24.4819 35.3601 27.223 32.6192 27.223 29.25C27.223 27.2108 25.3284 24.8849 23.4968 22.6355C22.6687 21.6186 21.8156 20.5707 21.1376 19.5488H21.1376ZM20.9956 32.9662C18.9768 32.9662 17.3344 31.3245 17.3344 29.3067C17.3344 29.1492 17.4619 29.0218 17.6193 29.0218C17.7767 29.0218 17.9042 29.1493 17.9042 29.3067C17.9042 31.0103 19.2909 32.3966 20.9957 32.3966C21.1529 32.3966 21.2804 32.5241 21.2804 32.6815C21.2804 32.8389 21.1528 32.9662 20.9956 32.9662L20.9956 32.9662Z",
    fill: "#FF1133"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlood);
export default __webpack_public_path__ + "static/media/blood.4b369260.svg";
export { ForwardRef as ReactComponent };